import React, { useEffect, useState } from "react";

export default function RotationGizmoLabel() {
  const [label, setLabel] = useState(null);

  useEffect(() => {
    const onDrag = (event) => {
      const detail = event?.detail || {};
      const axisLetter = detail.axisLetter || "";
      const degrees = typeof detail.degrees === "number" ? detail.degrees : null;
      const clientX = typeof detail.clientX === "number" ? detail.clientX : null;
      const clientY = typeof detail.clientY === "number" ? detail.clientY : null;
      if (degrees == null || clientX == null || clientY == null) return;
      setLabel({ axisLetter, degrees, clientX, clientY });
    };
    const onDragEnd = () => setLabel(null);
    window.addEventListener("rotation-gizmo-drag", onDrag);
    window.addEventListener("rotation-gizmo-drag-end", onDragEnd);
    return () => {
      window.removeEventListener("rotation-gizmo-drag", onDrag);
      window.removeEventListener("rotation-gizmo-drag-end", onDragEnd);
    };
  }, []);

  if (!label) return null;

  return (
    <div
      className="pointer-events-none fixed z-[10000] inline-block rounded border border-gray-300/60 bg-gray-900/80 px-2 py-1 text-xs text-gray-100 shadow-md select-none whitespace-nowrap"
      style={{
        left: label.clientX,
        top: label.clientY,
        transform: "translate(14px, 14px)",
      }}
    >
      {`${label.axisLetter}: ${label.degrees >= 0 ? "+" : ""}${label.degrees.toFixed(1)}°`}
    </div>
  );
}
